import React, { useEffect, useState } from "react";
import "./Post.scss";

const API_KEY = "AIzaSyDerPB7o69WYn5MU-vSsHtObG2Q9IGkKu0"; 
const CHANNEL_ID = "UCjMaDHi8-GZRK4oagAvBWLQ"; 

const Post = () => {
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch(
          `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=10`
        );
        const data = await res.json();
        console.log("API Response:", data);

        if (!data.items) {
          setError("No videos found. Check your API key or quota.");
          return;
        }

        const filtered = data.items.filter(
          (item) => item.id.kind === "youtube#video" && item.id.videoId && item.snippet
        );

        setVideos(filtered);
      } catch (err) {
        console.error("Error fetching videos:", err);
        setError("Failed to fetch videos.");
      }
    };

    fetchVideos();
  }, []);

  return (
    <div className="shorts-container">
      {error && <p className="error">{error}</p>}

      {videos.length === 0 && !error && (
        <p className="loading">Loading YouTube Shorts...</p>
      )}

      {videos.map((video, index) => (
        <div className="short-box" key={index}>
          <iframe
            src={`https://www.youtube.com/embed/${video.id.videoId}?autoplay=0&mute=0&controls=1&loop=1&playlist=${video.id.videoId}&rel=0`}
            title={video.snippet.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ))}
    </div>
  );
};

export default Post;
